<!--
  Aceleres -- adaptador para reusar o visualizador de PDF do chat fora de um
  balao de mensagem.

  O PdfConversationViewer chama useMessageContext(), que lanca
  "Component is missing a parent <Message /> component." quando nao encontra o
  provide. Esse contexto nao e usado para desenhar o PDF: ele alimenta os botoes
  de acao (reagir, destacar, fixar, excluir), que despacham para a store.

  Por isso o wrapper exige a mensagem real: sem ela os botoes agiriam sobre
  dados vazios. Quem monta este componente deve garantir que a mensagem veio da
  conversa aberta.
-->
<script setup>
import { computed } from 'vue';
import { provideMessageContext } from 'dashboard/components-next/message/provider.js';
import PdfConversationViewer from 'dashboard/components-next/message/bubbles/PdfConversationViewer.vue';

const props = defineProps({
  // Aceleres 2026-08-17: deixou de ser obrigatorio. O documento aberto pela
  // lista de midias nem sempre tem a mensagem carregada na store (veio de
  // outra conversa, ou a pagina dela ainda nao foi buscada), e exigi-la aqui
  // era o que mandava esses PDFs para uma ABA NOVA em vez de abrirem na
  // propria pagina. Sem mensagem o leitor abre na mesma, e as acoes que
  // dependem dela ja se desligam sozinhas: PdfConversationViewer marca os
  // botoes com `:disabled="!messageId"` e os handlers saem cedo.
  message: {
    type: Object,
    default: () => ({}),
  },
  url: {
    type: String,
    required: true,
  },
  fileName: {
    type: String,
    default: '',
  },
});

defineEmits(['close']);

const message = computed(() => props.message || {});

provideMessageContext({
  id: computed(() => message.value.id),
  conversationId: computed(() => message.value.conversation_id),
  content: computed(() => message.value.content),
  attachments: computed(() => message.value.attachments || []),
  messageType: computed(() => message.value.message_type),
  status: computed(() => message.value.status),
  contentAttributes: computed(() => message.value.content_attributes || {}),
  private: computed(() => Boolean(message.value.private)),
  createdAt: computed(() => message.value.created_at),
  sourceId: computed(() => message.value.source_id),
  // O painel de contato nao expoe exclusao; o balao do chat continua sendo o
  // lugar para isso.
  canDelete: computed(() => false),
});
</script>

<template>
  <div class="acl-contact-pdf-viewer absolute inset-0">
    <PdfConversationViewer
      :url="url"
      :file-name="fileName"
      @close="$emit('close')"
    />
  </div>
</template>
